import { useEffect } from "react";
import { Particle } from "./animation/particles";
import { GradientMesh } from "./animation/gradientMesh";
import { startSmoothScroll, stopSmoothScroll } from "./animation/smoothScroll";
import { NavBar } from "./components/navbar";
import HomePage from "./page/homePage";

function App() {
  useEffect(() => {
    startSmoothScroll();
    return () => stopSmoothScroll();
  }, []);

  return (
    <div>
      <GradientMesh />
      <NavBar />
      <Particle />
      <HomePage />
    </div>
  );
}

export default App;
